import logo from '../assets/images/GuardianLogo.png';
import adhocApiProfilerIcon from '../assets/images/home/AdhocApiProfiler.png';
import agentTaskManagerIcon from '../assets/images/home/AgentTaskManager.png';
import apiProfilerIcon from '../assets/images/home/ApiProfiler.png';
import cocoIcon from '../assets/images/home/Coco.png';
import componentsIcon from '../assets/images/home/Components.png';
import prGuardianIcon from '../assets/images/home/PRGuardian.png';
import untrimmedProfilesIcon from '../assets/images/home/UntrimmedProfiles.png';

export type SiteBranding = {
    name: string;
    icon: string;
};

const defaultBranding: SiteBranding = {
    name: 'PR Guardian',
    icon: logo,
};

function getRoutePath(pathname: string): string {
    const path = pathname.toLowerCase().split(/[?#]/, 1)[0];
    const segments = path.split('/').filter(Boolean);

    if (segments[0] === 'service' && segments.length >= 3) {
        return `/${segments.slice(2).join('/')}`;
    }

    return segments.length === 0 ? '/' : `/${segments.join('/')}`;
}

export function isPrGuardianPath(pathname: string): boolean {
    const routePath = getRoutePath(pathname);
    const firstSegment = routePath.split('/').filter(Boolean)[0] ?? '';

    return (
        routePath === '/' ||
        firstSegment === 'faq' ||
        firstSegment === 'backfill' ||
        firstSegment === 'commitdetails' ||
        firstSegment === 'mycommits' ||
        firstSegment === 'allcommits'
    );
}

export function getSiteBranding(pathname: string): SiteBranding {
    const routePath = getRoutePath(pathname);

    if (routePath === '/') {
        return { name: 'PR Guardian', icon: cocoIcon };
    }

    if (routePath.startsWith('/agenttasks')) {
        return { name: 'Agent Task Manager', icon: agentTaskManagerIcon };
    }

    if (routePath.startsWith('/dailyapiprofiles') || routePath.startsWith('/requesttimeline')) {
        return { name: 'API Profiles', icon: apiProfilerIcon };
    }

    if (routePath.startsWith('/adhocapiprofiler') || routePath.startsWith('/adhoc-profiles')) {
        return { name: 'Ad hoc API Profiler', icon: adhocApiProfilerIcon };
    }

    if (routePath.startsWith('/profiles')) {
        return { name: 'Untrimmed Profiles', icon: untrimmedProfilesIcon };
    }

    if (routePath.startsWith('/components') || routePath.startsWith('/componentdetails')) {
        return { name: 'Components', icon: componentsIcon };
    }

    if (isPrGuardianPath(routePath)) {
        return { name: 'PR Guardian', icon: prGuardianIcon };
    }

    return defaultBranding;
}
